import { render, staticRenderFns } from "./CollegeSimply.vue?vue&type=template&id=4e85f53d&lang=html"
import script from "./CollegeSimply.vue?vue&type=script&lang=js"
export * from "./CollegeSimply.vue?vue&type=script&lang=js"
import style0 from "./CollegeSimply.vue?vue&type=style&index=0&id=4e85f53d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports